// src/api/adminViewApi.ts
import { AdminApproverHistory } from "../types/adminApproverHistory";
import axiosInstance from "./axiosInstance";

export const getApproverHistory = async (): Promise<AdminApproverHistory[]> => {
  try {
    const response = await axiosInstance.get("/api/admin/approver-logs");
    return response.data; // TypeScript will infer the return type as ConsolidatedViewRow[]
  } catch (error) {
    console.error("Error fetching consolidated view data:", error);
    throw error;
  }
};

export const getApproverHistoryById = async (
  adminId: string | number,
): Promise<AdminApproverHistory[]> => {
  try {
    const response = await axiosInstance.get(`/api/admin/approver-logs/${adminId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching approver history by id:", error);
    throw error;
  }
};
